var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: _vm.colorObject,
    attrs: {
      "id": "root"
    }
  }, [_c('div', {
    staticClass: "leeselect-background"
  }), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6 offset-md-3 col-xxs-12"
  }, [_c('b-card', {
    staticClass: "cs-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm.authThemeConfig.logo_url ? _c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": _vm.authThemeConfig.logo_url
    }
  }) : _vm._e()]), _c('router-view')], 1)])], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }